import { SET, UNSET, SET_BALANCE, SET_PASSWORDS, UPDATE_STATE, SET_WINNING_JACKPOT, SHOW_WON_JACKPOT } from './mutation-types';

export default {
    [SET]: ({ commit, dispatch }, player) => {
        commit(SET, player);

        // stop polling of anonymous jackpots on login
        if (store && store.hasModule('jackpots')) dispatch('jackpots/stop');
    },
    [UNSET]: ({ commit, dispatch }) => {
        commit(UNSET);

        // restart polling of anonymous jackpots on logout
        if (store && store.hasModule('jackpots')) dispatch('jackpots/start');
    },
    [SET_BALANCE]: ({ commit }, balance) => {
        commit(SET_BALANCE, balance);
    },
    [SET_PASSWORDS]: ({ commit }, params) => {
        commit(SET_PASSWORDS, params);
    },
    [UPDATE_STATE]: ({ commit, dispatch }, playerState) => {
        commit(UPDATE_STATE, playerState);

        // store part of player's state as jackpots state
        if (store && store.hasModule('jackpots')) dispatch('jackpots/set-state', playerState);
    },
    [SET_WINNING_JACKPOT]: ({ commit }, winningJackpot) => {
        commit(SET_WINNING_JACKPOT, winningJackpot);
    },
    [SHOW_WON_JACKPOT]: ({ commit }, wonJackpot) => {
        commit(SHOW_WON_JACKPOT, wonJackpot);
    }
};



// WEBPACK FOOTER //
// ./_common/data/player/actions.js